<template>
    <div class="container">
        <div class="header">
            <div class="image-box">
                <van-swipe :autoplay="3000" class="swipe-box">
                    <van-swipe-item v-for="(image, index) in swipeArray" :key="index">
                        <van-image 
                            class="swipe-itme"
                            lazy-load
                            :src="image"
                        />
                    </van-swipe-item>
                </van-swipe>
            </div>
            <div class="header-line"></div>
        </div>
        <ul class="body">

            <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoad"
            >

                <li 
                    v-for="(item, index) in narrators" :key="index"
                    class="reder-item f-s-b"
                >
                    <van-image 
                        class="left-image-box"
                        lazy-load
                        fit="cover"
                        :src="item.image"
                    />
                    <div class="right-info-box f-s-b">
                        <div class="name ellipsis">{{item.name}}</div>
                        <div class="year">讲解年限: {{item.year}}年</div>
                        <div class="good-at">擅长: {{item.goodAt}}</div>
                        <div class="level leve-up" v-if="item.type === 3">
                            <i class="iconfont icontianchongxing-"></i>
                            <span>高级讲解员</span>
                        </div>
                        <div  class="level leve-middle" v-else-if="item.type === 2">
                            <i class="iconfont iconxing"></i>
                            <span>中级讲解员</span>
                        </div>
                        <div  class="level leve-below" v-else-if="item.type === 1">
                            <i class="iconfont iconaixin"></i>
                            <span>初级讲解员</span>
                        </div>
                    </div>
                </li>

            </van-list>   

        </ul>
    </div>
</template>

<script>
    import { 
        Swipe, 
        SwipeItem, 
        List,
    } from 'vant';
    import http from '@js/http-zyz.js';
    import {
        narratorListUrl,
    } from '@js/volunteerUrl.js';
    export default {
        data() {
            return {
                swipeArray: [
                    require('@image/home/34.png'),
                ],
                narrators: [],
                loading: false,
                finished: false,
            }
        },
        created() {
        },
        methods: {
            onLoad() {
                // // 异步更新数据
                // // setTimeout 仅做示例，真实场景中一般为 ajax 请求
                // setTimeout(() => {
                //     this.randomList();
                //     // 加载状态结束
                //     this.loading = false;
                //     if (this.narrators.length >= 60) {
                //         this.finished = true;
                //     }
                // }, 1000);
                //  我准备好了分页的 结果后台没有分页..
                this.getNarratorList();
            },
            getNarratorList(){
                http.get(narratorListUrl)
                    .then(res=>{
                        var {
                            success = true,
                            data: {
                                data: array = []
                            }
                        } = res;
                        if(success){
                            array.map(item=>{
                                this.narrators.push({
                                    image: item.picture,
                                    name: item.name,
                                    year: item.years,
                                    goodAt: item.good_at_name,
                                    goodAt: String(item.good_at_name).replace(/,/g, " "),
                                    type: Number(item.level) || 1,
                                    rawData: item,
                                });
                            })
                            this.finished = true;
                        }
                    })
                    .catch(error=>{
                        this.finished = true;
                    })
            },
            randomList(){
                var narrators = [
                        {
                            image: require('@image/home/wanglili.png'),
                            name: '王丽丽名字长',
                            year: 2,
                            goodAt: '历史',
                            type: 3,
                        },
                        {
                            image: require('@image/home/wanglili.png'),
                            name: '王丽丽名字长度',
                            year: 2,
                            goodAt: '历史',
                            type: 2,
                        },
                        {
                            image: require('@image/home/wanglili.png'),
                            name: '王丽丽名字长度测试',
                            year: 2,
                            goodAt: '历史',
                            type: 1,
                        },
                    ]
                for (let index = 0; index < (parseInt(Math.random()*10) + 20); index++) {
                    var tempIndex = parseInt(Math.random()*3);
                    this.narrators.push(narrators[tempIndex]);
                }
            },
        },
        components: {
            [Swipe.name]: Swipe,
            [SwipeItem.name]: SwipeItem,
            [List.name]: List,
        }
    }
</script>

<style lang="less" scoped>
    @import "./style/home-public-style.less";
    .container{
        position: relative;
        .header{
            .swipe-itme{
                width: 100%;
            }
            .image-box{
                height: 185px;
            }
            .header-line{
                height:47px;
                background:linear-gradient(270deg,rgba(32,107,148,1) 0%,rgba(14,57,91,1) 100%);
            }
        }
        .body{
            position: absolute;
            left: 0;
            right: 0;
            top: 197px;
            @paddingSize:7px;
            padding: @paddingSize;
            box-sizing: border-box;
            .reder-item{
                overflow: hidden;
                margin-bottom: @paddingSize;
                padding: 12px 20px;
                background:rgba(255,255,255,1);
                box-shadow:0px 1px 8px 0px rgba(212,206,218,0.5);
                border-radius:5px;
                @size:86px;
                .left-image-box{
                    height: @size;
                    width: @size;
                    border-radius:4px;
                    overflow: hidden;
                }
                .right-info-box{
                    flex-direction: column;
                    align-items: flex-start;
                    width: ~"calc(100% - 86px)";
                    height: @size;
                    position: relative;
                    padding-left: 16px;
                    box-sizing: border-box;
                    .name{
                        // height:23px;
                        width: ~'calc(100% - 92px)';
                        font-size:16px;
                        font-weight:500;
                        color:rgba(53,58,62,1);
                    }
                    .year,.good-at{
                        // height:17px;
                        font-size:12px;
                        font-weight:500;
                        color:rgba(152,156,165,1);
                    }
                    .level{
                        font-weight:500;
                        font-size: 14px;
                        position: absolute;
                        right: 0;
                        top: 0;
                        .iconfont{
                            margin-right: 5px;
                        }
                    }
                    .leve-up{
                        color: #D4AB35;
                    }
                    .leve-middle{
                        color: #2FB147;
                    }
                    .leve-below{
                        color: #4282FF;
                    }
                }
                &:last-child{
                    margin: 0;
                }
            }
        }
    }
</style>